import React, { useState, useMemo } from 'react';
import { getRecords } from '../utils/storage';

// 月曜始まり
const WEEKDAYS = ['月', '火', '水', '木', '金', '土', '日'];

// stampMap prop があればクラウドデータ、なければlocalStorageから生成
export default function CalendarView({ stampMap: stampMapProp }) {
  const today = new Date();
  const [year, setYear]   = useState(today.getFullYear());
  const [month, setMonth] = useState(today.getMonth());

  const localStampMap = useMemo(() => {
    if (stampMapProp) return null; // propsがあればlocalStorageは使わない
    const records = getRecords();
    const map = {};
    records.forEach((r) => {
      if (!r.localDate) return;
      const stars = r.totalStars ?? 0;
      if (map[r.localDate] === undefined || stars > map[r.localDate]) {
        map[r.localDate] = stars;
      }
    });
    return map;
  }, [stampMapProp]);

  const stampMap = stampMapProp ?? localStampMap ?? {};

  const prevMonth = () => {
    if (month === 0) { setYear(y => y - 1); setMonth(11); }
    else setMonth(m => m - 1);
  };
  const nextMonth = () => {
    if (month === 11) { setYear(y => y + 1); setMonth(0); }
    else setMonth(m => m + 1);
  };

  const cells = useMemo(() => {
    const firstDayOfWeek = new Date(year, month, 1).getDay(); // 0=日
    // 月曜始まり：日曜(0)は6列目、月曜(1)は0列目
    const offset = (firstDayOfWeek + 6) % 7;
    const daysInMonth = new Date(year, month + 1, 0).getDate();
    const result = [];
    for (let i = 0; i < offset; i++) result.push(null);
    for (let d = 1; d <= daysInMonth; d++) result.push(d);
    return result;
  }, [year, month]);

  const todayStr  = `${today.getFullYear()}-${String(today.getMonth() + 1).padStart(2, '0')}-${String(today.getDate()).padStart(2, '0')}`;
  const monthStr  = `${year}-${String(month + 1).padStart(2, '0')}`;

  const getStamp = (day) => {
    if (!day) return null;
    const dateStr = `${monthStr}-${String(day).padStart(2, '0')}`;
    const stars = stampMap[dateStr];
    if (stars === undefined) return null;
    return stars >= 3 ? '🌟' : '⭐';
  };

  const isToday = (day) => {
    if (!day) return false;
    return `${monthStr}-${String(day).padStart(2, '0')}` === todayStr;
  };

  return (
    <div className="calendar-wrap">
      <div style={{ display:'flex', alignItems:'center', justifyContent:'space-between', marginBottom:12 }}>
        <button
          onClick={prevMonth}
          style={{ background:'#7C3AED', border:'none', borderRadius:10, color:'white',
            fontSize:20, fontWeight:'bold', width:36, height:36, cursor:'pointer',
            display:'flex', alignItems:'center', justifyContent:'center' }}
        >‹</button>
        <span style={{ fontSize:15, fontWeight:'bold', color:'#2E1065' }}>{year}年 {month + 1}月</span>
        <button
          onClick={nextMonth}
          style={{ background:'#7C3AED', border:'none', borderRadius:10, color:'white',
            fontSize:20, fontWeight:'bold', width:36, height:36, cursor:'pointer',
            display:'flex', alignItems:'center', justifyContent:'center' }}
        >›</button>
      </div>

      <div className="cal-grid">
        {/* 曜日ラベル：月曜始まり、土=index5、日=index6 */}
        {WEEKDAYS.map((w, i) => (
          <div
            key={w}
            className={`cal-weekday ${i === 6 ? 'sun' : i === 5 ? 'sat' : ''}`}
          >
            {w}
          </div>
        ))}

        {cells.map((day, i) => {
          const stamp   = getStamp(day);
          const todayCell = isToday(day);
          return (
            <div
              key={i}
              className={`cal-cell${day ? '' : ' empty'}${todayCell ? ' today' : ''}${stamp ? ' done' : ''}`}
            >
              {day && (
                <>
                  <span className="cal-day-num">{day}</span>
                  <span className="cal-stamp">
                    {stamp || <span className="cal-dot" />}
                  </span>
                </>
              )}
            </div>
          );
        })}
      </div>
    </div>
  );
}
